import React, { useEffect, useState } from 'react';
import { Paper, Typography, Box, Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { DataGridPro as DataGrid } from '@mui/x-data-grid-pro';
import { QuickSearchToolbar } from '../QuickSearch';
import { getRancherColumn, SearchRancherKey } from '../GridColumns';
import { RanchdbStats } from './RanchdbStats';

export const RanchTable = ({
  ranchList,
  metricData,
  setRanchList,
  status,
  allData,
  fieldLoading,
  metricLoading,
  setPage,
  page,
  pageSize,
  setPageSize,
  searchText, // Add searchText prop
  onSearch, // Add onSearch callback
  onClearSearch // Add clear search callback
}) => {
  const navigate = useNavigate();

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };

  const handlePageSizeChange = (newSize) => {
    setPageSize(newSize);
  };

  // Filter by status (only for local filtering if needed)
  const filterDataOnStatus = (status) => {
    if (!allData?.fieldDetails) return;
    if (status === 'ALL') {
      setRanchList([...allData.fieldDetails]);
      return;
    }
    const newRanchList = allData.fieldDetails.filter((ele) => ele.status === status);
    setRanchList([...newRanchList]);
  };

  useEffect(() => {
    filterDataOnStatus(status);
  }, [status]);

  const onClickRow = (row) => {
    navigate('/dashboard/ranchDetail', {
      state: {
        id: row?.fieldId,
        producerId: row?.producerId,
        partnerId: row?.oldPartnerId,
        rowData: row
      }
    });
  };

  return (
    <Paper elevation={10} sx={{ width: '100%', marginTop: 5, padding: 4 }}>
      <RanchdbStats stat={metricData || {}} />
      <Grid container direction="column" sx={{ height: '110vh', flex: 1 }}>
        <Typography variant="h5" sx={{ margin: '1rem' }}>
          Onboarded Ranches
        </Typography>
        <DataGrid
          rows={ranchList || []}
          columns={getRancherColumn(onClickRow)}
          loading={fieldLoading || metricLoading}
          pagination
          paginationMode="server"
          rowCount={allData?.total || 0}
          page={page}
          pageSize={pageSize}
          onPageChange={handlePageChange}
          onPageSizeChange={handlePageSizeChange}
          disableSelectionOnClick
          components={{
            Toolbar: QuickSearchToolbar,
            NoRowsOverlay: () => (
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  height: '100%'
                }}
              >
                {searchText ? 'No matching ranches found' : 'No Ranch'}
              </Box>
            )
          }}
          componentsProps={{
            toolbar: {
              value: searchText,
              onChange: (event) => onSearch(event.target.value), // Use callback
              clearSearch: () => onClearSearch() // Use callback
            }
          }}
          sx={{
            '& .MuiDataGrid-columnHeaderTitle': {
              textOverflow: 'clip',
              whiteSpace: 'break-spaces',
              lineHeight: 1
            }
          }}
        />
      </Grid>
    </Paper>
  );
};